import { SpaceContext } from '@/contexts/SpaceContext'
import { useQuery } from '@tanstack/react-query'
import { useContext } from 'react'
import { QueryMap } from '../queryMap'
import {
  FlatfileQuery,
  FlatfileRequestType,
  FlatfileResponseType,
  UseQueryOptionsType,
} from '../types'

const query: FlatfileQuery = 'getAllWorkbooks'

export const useQueryGetAllWorkbooks = (
  params: FlatfileRequestType<typeof query>,
  options?: UseQueryOptionsType<typeof query>
) => {
  const { httpClient } = useContext(SpaceContext)
  return useQuery<FlatfileResponseType<typeof query>>(
    QueryMap[query].generateQueryKey(params),
    async () => httpClient[query](params),
    {
      staleTime: Infinity,
      ...options,
    }
  )
}
